module.exports = __webpack_public_path__ + "pic6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic6.jpg
// module id = 1526
// module chunks = 13